import { CouponStatus } from "src/containers/insurances/constants/coupon-status";
import { DayjsUtils } from "src/libs/dayjs-utils";
import { Coupon } from "src/shared/models/payment-coupon.model";
import { PaymentSummary } from "src/shared/models/payment-summary.model";

type Result = { hasOverdued: boolean; howManyOverdued: number };

const isPaymentInProcess = (debitMembership: any, coupon: Coupon): boolean => {
    const expirationDate = coupon?.expirationDate as string;
    // if the payment is probably by DA, do not count it
    // because can late to process it
    const isPaymentByDA =
        debitMembership && DayjsUtils.isPastUntil(expirationDate, 7);
    // so, the payment is in process if the payment is by DA or gateway
    return isPaymentByDA || (coupon.inPaymentProcessing as boolean);
};

export function hasOverdueCoupons(summary?: PaymentSummary): Result {
    if (!summary) {
        return {
            hasOverdued: false,
            howManyOverdued: 0,
        };
    }
    const coupons = summary.coupons ?? [];
    const { debitMembership } = summary;
    let hasOverdued = false;
    let howManyOverdued = 0;

    // how many coupons are overdued
    coupons.forEach((coupon) => {
        const expiredBecauseDate = DayjsUtils.isPast(
            coupon.expirationDate as string
        );
        const pending = coupon.status?.toUpperCase() === CouponStatus.OVERCOME;
        const expired = coupon.status?.toUpperCase() === CouponStatus.OVERDUED;

        if (!pending && expired && expiredBecauseDate) {
            if (!isPaymentInProcess(debitMembership, coupon)) {
                howManyOverdued += 1;
                hasOverdued = true;
            }
        }
    });

    return { hasOverdued, howManyOverdued };
}
